import { IAddress, IUser } from "./userType";

export enum SubscriptionStatus {
  active = "active",
  inactive = "inactive",
  cancelled = "cancelled",
  pendingCancellation = "pending_cancellation",
  pending = "pending",
  paymentFailed = "paymentFailed",
}

export interface ISubscription {
  userId?: string;
  paymentMethod?: any;
  paymentMethodId?: string;
  planId?: any;
  amount?: any;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  address?: IAddress | null;
  stripeSubscriptionId?: string;
  canceledAt?: any;
  cancellationReason?: string;
  createdAt?: any;
  endDate?: any;
  startDate?: any;
  stripeCustomerId?: string;
  subscriptionStatus?: string;
  user?: IUser;
  _id?: string;
}

export interface IUpdateSubscriptionPaymentMethod {
  userId?: string;
  firstName: string;
  lastName: string;
  paymentMethodId: string;
  address?: IAddress | null;
}

export interface ICancelMemberSubscription {
  userId?: string;
  subscriptionId: string;
  cancellationReason: string;
}
